import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import toast from 'react-hot-toast'
import { templateApi } from './templates.service'
import type {
  CreateTemplateInput,
  MessageChannel,
  UpdateTemplateInput,
} from './templates.types'

const KEY = 'message-templates'

export function useTemplates(channel: MessageChannel, activeOnly?: boolean) {
  return useQuery({
    queryKey: [KEY, channel, { activeOnly: !!activeOnly }],
    queryFn: () => templateApi.list(channel, activeOnly),
  })
}

function invalidate(queryClient: ReturnType<typeof useQueryClient>) {
  queryClient.invalidateQueries({ queryKey: [KEY] })
}

export function useCreateTemplate() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (data: CreateTemplateInput) => templateApi.create(data),
    onSuccess: () => {
      invalidate(queryClient)
      toast.success('Plantilla creada')
    },
    onError: (error: any) => toast.error(error.message || 'No se pudo crear la plantilla'),
  })
}

export function useUpdateTemplate() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: UpdateTemplateInput }) =>
      templateApi.update(id, data),
    onSuccess: () => invalidate(queryClient),
    onError: (error: any) =>
      toast.error(error.message || 'No se pudo actualizar la plantilla'),
  })
}

export function useDeleteTemplate() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (id: string) => templateApi.delete(id),
    onSuccess: () => {
      invalidate(queryClient)
      toast.success('Plantilla eliminada')
    },
    onError: (error: any) =>
      toast.error(error.message || 'No se pudo eliminar la plantilla'),
  })
}
